import { useApi } from 'api/api-context';
import { DataSelect, DataSelectInheritedProps } from 'components/selects/DataSelect';
import { useCallback } from 'react';

export type FaultAuditReference = 'fixedBy' | 'recordedBy';

/** Audit actors scoped to accessible resolved faults, including historical users. */
export function FaultAuditUserSelect({
  reference,
  ...props
}: DataSelectInheritedProps & { reference: FaultAuditReference }) {
  const { getAction } = useApi();
  const action = useCallback(async () => {
    const users = await getAction('DeviceFaultAuditUserGetOptions')({ query: { reference } });
    return users
      .map((user) => ({ value: String(user.userId), label: user.fullName ?? `${user.firstName} ${user.lastName}` }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [getAction, reference]);
  return (
    <DataSelect
      key={reference}
      action={action}
      labelProp="label"
      valueProp="value"
      autoSelectSingleResult={false}
      {...props}
    />
  );
}
